/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* VDK Web ProgramGuide Component (@accedo/vdkweb-epg) 7.2.8
* 
*******************************************************************************/
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _channelLane = _interopRequireDefault(require("./channelLane.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 *
 * A simple container lane for a channel where you can specify height
 * and theme/style.
 *
 * It is exported as a pure component with the recompose hoc React.memo(ChannelLane).
 *
 * @param {object} props See prop types
 * @returns {node} The component
 */
var ChannelLane = function ChannelLane(_ref) {
  var children = _ref.children,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 0 : _ref$height,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 0 : _ref$width,
    _ref$vertical = _ref.vertical,
    vertical = _ref$vertical === void 0 ? false : _ref$vertical,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _channelLane["default"] : _ref$theme;
  var _style = _objectSpread({
    width: width,
    height: height
  }, style);
  var className = (0, _classnames["default"])(theme.channelLane, _defineProperty({}, theme.vertical, vertical));
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className,
    style: _style
  }, children);
};
ChannelLane.propTypes = {
  /** Any react nodes are accepted as children */
  children: _propTypes["default"].node,
  /** The height of the channel lane */
  height: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  /** Style to be used on the container div */
  style: _propTypes["default"].object,
  /** A theme definition with classname strings */
  theme: _propTypes["default"].shape({
    channelLane: _propTypes["default"].string,
    vertical: _propTypes["default"].string
  }),
  /** If the programs are being layed out vertically in a channel lane */
  vertical: _propTypes["default"].bool,
  /** The width of the channel lane */
  width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
};
var _default = /*#__PURE__*/_react["default"].memo(ChannelLane);
exports["default"] = _default;